import React, { useState } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from './auth'
import { useAuth } from './authContext'

const Login2 = () => {
    const { userLoggedIn } = useAuth()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isSigningIn, setIsSigningIn] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const onSubmit = async (e) => {
        e.preventDefault()
        if(!isSigningIn) {
            setIsSigningIn(true)
            await doSignInWithEmailAndPassword(email, password)
            // doSendEmailVerification()
        }
    }

    const onGoogleSignIn = (e) => {
        e.preventDefault()
        if (!isSigningIn) {
            setIsSigningIn(true)
            doSignInWithGoogle().catch(err => {
                setIsSigningIn(false)
            })
        }
    }

    return (
        <div >
Last Updated: 11/17/2025

Your Property Guys (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you contact us, use our website, or request home services such as plumbing, HVAC, roofing, cleaning, lawn care, or general maintenance.

By contacting our business (including by phone, SMS, or through our website), you agree to the terms outlined in this Privacy Policy.

⸻

1. Information We Collect

We may collect the following types of information:

A. Information You Provide Directly
	•	Name
	•	Phone number
	•	Email address
	•	Address or service location
	•	Details about the home service you are requesting
	•	Photos or descriptions you send related to your service request

B. Automatically Collected Information

When you visit our website, we may automatically collect:
	•	IP address
	•	Browser type
	•	Device type
	•	Pages visited
	•	Time spent on our site

These analytics help improve our website and service quality.

⸻

2. How We Use Your Information

We use the collected information solely to:
	•	Respond to your home service request
	•	Communicate regarding scheduling, pricing, or technician arrival
	•	Provide estimates or updates on your requested service
	•	Confirm or follow up on work performed
	•	Improve service quality and customer experience

We do not send marketing or promotional SMS messages.
We only message users who contact us first.

⸻

3. SMS/Text Messaging Policy

By calling or texting our published business phone number, you consent to receive service-related text messages from Your Property Guys.

These messages may include:
	•	Confirmations of your request
	•	Technician arrival updates
	•	Scheduling coordination
	•	Follow-up or service-completion messages

Opt-Out:
You may opt out of text messages at any time by replying STOP.
You may also request removal by contacting us at info@propertyguyshq.com.

We do not send marketing texts, and we do not share mobile numbers with third parties for marketing purposes.

⸻

4. How We Share Your Information

We do not sell, rent, or trade your personal information.

We may share your information only with:
	•	Internal staff or technicians assigned to your job
	•	Third-party contractors or service partners required to complete your request
	•	Service providers who help operate our business (billing, scheduling, etc.)

All shared information is used only to fulfill your service request.

⸻

5. Data Security

We implement reasonable physical, technical, and administrative safeguards to protect your information from unauthorized access, disclosure, or misuse.

However, no system is 100% secure, and we cannot guarantee absolute security.

⸻

6. Cookies & Tracking Technologies

Our website may use cookies or similar technologies to improve user experience, track analytics, and customize content.
You may disable cookies in your browser settings.

⸻

7. Your Rights

Depending on your jurisdiction, you may have the right to:
	•	Request access to the personal data we hold
	•	Request corrections to inaccurate data
	•	Request deletion of your data
	•	Withdraw consent for SMS messaging
	•	Request information about data usage

To exercise any of these rights, email: info@propertyguyshq.com

⸻

8. Children’s Privacy

We do not knowingly collect information from children under 13.
If you believe we may have received information from a child, contact us and we will remove it promptly.

⸻

9. Changes to This Policy

We may update this Privacy Policy occasionally.
The updated policy will always be posted on this page with the latest revision date.

⸻

10. Contact Us

If you have any questions about this Privacy Policy or how we handle your information, please contact us:

Your Property Guys
Email: info@propertyguyshq.com
Website: https://propertyguyshq.com
        </div>
    )
}

export default Login2